<ng-container [ngSwitch]="block?.type" *ngFor="let block of data.blocks; let i = index">
  <!-- Header -->
  <app-heading *ngSwitchCase="'header'" [node]="block?.data"></app-heading>

  <!-- Paragraph -->
  <app-paragraph *ngSwitchCase="'paragraph'" [node]="block?.data"></app-paragraph>

  <!-- List -->
  <app-list *ngSwitchCase="'list'" [node]="block?.data"></app-list>

  <!-- Delimiter -->
  <app-delimiter *ngSwitchCase="'delimiter'"></app-delimiter>

  <!-- Quote -->
  <app-quote *ngSwitchCase="'quote'" [node]="block?.data"></app-quote>

  <!-- Button -->
  <app-html-button *ngSwitchCase="'button'" [node]="block?.data"></app-html-button>

  <!-- Single Image -->
  <app-image *ngSwitchCase="'image'" [node]="block?.data"></app-image>

  <!-- Multi Image -->
  <app-multiimage *ngSwitchCase="'image_grid'" [node]="block?.data"></app-multiimage>

  <!-- CTA -->
  <app-cta *ngSwitchCase="'cta'" [node]="block?.data"></app-cta>

  <!-- Table -->
  <app-table *ngSwitchCase="'table'" [node]="block?.data"></app-table>

  <!-- FAQs -->
  <app-faqs *ngSwitchCase="'faqs'" [node]="block?.data"></app-faqs>

  <!-- Contact List -->
  <app-contact-list *ngSwitchCase="'contact_list'" [node]="block?.data"></app-contact-list>

  <!-- Participating Stores -->
  <app-participating-stores *ngSwitchCase="'participating_stores'" [node]="block?.data"></app-participating-stores>

  <!-- Product Grid -->
  <app-product-grid *ngSwitchCase="'product_grid'" [node]="block?.data"></app-product-grid>

  <!-- Image Card -->
  <app-image-card *ngSwitchCase="'image_card'" [node]="block?.data"></app-image-card>

  <!-- Twitter -->
  <app-twitter *ngSwitchCase="'twitter'" [node]="block?.data"></app-twitter>

  <!-- Facebook -->
  <app-facebook *ngSwitchCase="'facebook'" [node]="block?.data"></app-facebook>

  <!-- Instagram -->
  <app-instagram *ngSwitchCase="'instagram'" [node]="block?.data"></app-instagram>

  <!-- YouTube -->
  <app-youtube *ngSwitchCase="'youtube'" [node]="block?.data"></app-youtube>

  <!-- Form -->
  <app-form *ngSwitchCase="'form'" [node]="block?.data" [formTitle]="formTitle" [publicForm]="publicForm"></app-form>

  <!-- Explore -->
  <app-explore *ngSwitchCase="'explore'" [node]="block?.data"></app-explore>

  <!-- Hero -->
  <app-hero *ngSwitchCase="'hero'" [node]="block?.data"></app-hero>
</ng-container>